import { CanMatchFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { StoreState } from '@store/store.state';
import { userSelectors } from '@store/selectors/user.selectors';
import { combineLatest, debounceTime, filter, take } from 'rxjs';
import { map, withLatestFrom } from 'rxjs/operators';
import { UserCountry } from '@core/domain/model/user/auth-user.model';
import { AcRoutingService } from '@core/services/routing/ac-routing.service';
import { appSelectors } from '@store/selectors/app.selectors';

export const countryGuardFn: (country: UserCountry) => CanMatchFn = (country: UserCountry) => () => {
  const store = inject(Store<StoreState>);
  const router = inject(Router);
  const check$ = combineLatest([store.select(appSelectors.generalLoading), store.select(userSelectors.webIsReady)]).pipe(
    debounceTime(100),
    filter(([isLoading, webIsReady]) => !isLoading && webIsReady)
  );
  return check$.pipe(
    withLatestFrom(store.select(userSelectors.authUser), store.select(userSelectors.authUserError)),
    filter(([, user, userError]) => user != null || userError != null),
    take(1),
    map(([, user]) => {
      if (user?.country === country) {
        return true;
      }
      return router.createUrlTree(AcRoutingService.PROCEDURE_SELECTOR_ROUTE());
    })
  );
};
